module.exports = __webpack_public_path__ + "img/xmas-new_m.8d7332d.webp";